module.exports = "https://health.dajiuxing.com.cn/img/views/binding/img/sp.jpg"


//////////////////
// WEBPACK FOOTER
// ./build/cdn-img-stub.js?path=views%2Fbinding%2Fimg%2Fsp.jpg
// module id = UZRX
// module chunks = 93